"use strict";
import "lodash";
import { svc_fetchAll, svc_addOne, svc_editOne, svc_deleteOne, svc_search } from "@/services";
import { showServerResponse } from "@/utils/message";
import { convertISODateTimeToString } from "@/utils/convertTime";
import logger from "@/utils/logger";

const endpointBasePrefix = "signage";

const Model = {
	namespace: "m_DigitalSignage",
	state: {
		digitalSignage: [],
	},
	reducers: {
		handleFetchAll(state, { payload: { digitalSignage } }) {
			return { ...state, digitalSignage };
		},
	},
	effects: {
		*fetchAll({ brandId, outletId, scopeToken }, { call, put }) {
			let digitalSignage = yield call(svc_search, endpointBasePrefix, { brand: brandId, outlet: outletId });

			_.forEach(digitalSignage, function (row) {
				row.key = row.id;
				row = convertISODateTimeToString(row, ["enrolment_date"]);
				if (outletId && !scopeToken.allowedDerivedOutlets.includes(outletId)) row.disableEdit = true;
				if (brandId && !outletId && !scopeToken.allowedBrands.includes(brandId)) row.disableEdit = true;
			});

			yield put({
				type: "handleFetchAll",
				payload: { digitalSignage },
			});

			return digitalSignage;
		},
		*addOne({ payload }, { call, put }) {
			payload = _.omit(payload, ["key"]);
			const response = yield call(svc_addOne, endpointBasePrefix, payload);
			return showServerResponse(response);
		},
		*editOne({ payload }, { call, put }) {
			payload = _.omit(payload, ["key"]);
			const response = yield call(
				svc_editOne,
				endpointBasePrefix,
				payload,
				"id",
				payload.name,
			);
			return showServerResponse(response);
		},
		*deleteOne({ payload }, { call, put }) {
			payload = _.omit(payload, ["key"]);
			const response = yield call(
				svc_deleteOne,
				endpointBasePrefix,
				payload,
				"id",
				payload.name,
			);
			return showServerResponse(response);
		},
	},
	subscriptions: {},
};

export default Model;
